// src/SweetTradingPro.jsxxxx
import React, { useState, useEffect, useRef } from "react";
import {
  motion,
  useScroll,
  useTransform,
  useSpring,
  useReducedMotion,
  useInView,
  AnimatePresence,
} from "framer-motion";

import { auth } from "./firebase"; // path corretto al tuo file config
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";

import PurchasePopup from "./PurchasePopup";



import { Link, useNavigate } from "react-router-dom";
import emailjs from "emailjs-com";




import logoST from "./assets/logo-st.png";

import { FaRobot, FaChartLine, FaBolt, FaStar, FaBars } from "react-icons/fa";

import option1 from "./assets/option-1.svg";
import option4 from "./assets/option-4.svg";
import option6 from "./assets/option-6.svg";
import option7 from "./assets/option-7.svg";
import option8 from "./assets/option-8.svg";
import option9 from "./assets/option-9.svg";
import option10 from "./assets/option-10.svg";
import option11 from "./assets/option-11.svg";

/* ---------------- COPY STATICO ---------------- */

const EN_COPY = {
  heroTitle: "A NEW TRADING GENERATION",
  heroSubtitle:
    "98% of traders fail. But not today, not anymore. We’re finally here to change that statistic forever — join the revolution now.",
  buttonText: "Discover Candy Bot",
  buttonLink: "#promo-section",
  

 


  clockSection: {
    title: "every tick count",
    line1:
      "Every second, 24 hours a day, 5 days a week, our bot analyzes the markets",
    line2: " to identify the best trading opportunities.",
  },

  whySection: {
    title: "Sweet and Powerful",
    description:
      "Is there anything sweeter than money? Yes: easy money. Unfortunately, easy money doesn’t exist — but Candy Bot is here to sweeten the deal and do the heavy lifting for you.",
    features: [
      {
        title: "AI Power",
        highlight: "responsible for inevitable change",
        description:
          "Candy Bot uses advanced AI with proprietary neural networks to analyze global markets in real time. Our system combines deep learning, pattern recognition, and predictive analytics to dynamically adapt to market volatility.",
        image: "/ai.jpg",
        icon: "FaRobot",
      },
      {
        title: "Outstanding Results",
        highlight: "The one, the first, the best",
        description:
          "Built to turn the best opportunities into reality. Optimized to minimize errors and maximize profits. Our adaptive algorithms continuously refine trading strategies and enforce robust risk-management protocols.",
        image: "/performance.jpg",
        icon: "FaChartLine",
      },
      {
        title: "Market-Optimized",
        highlight: "Timing is everything",
        description:
          "Forex, stocks, or crypto — each model has a specialization tailored to the context it operates in, so it can seize the right moment every time.",
        image: "/forex.jpg",
        icon: "FaBolt",
      },
    ],
  },

  processSection: {
    title: "The 3-Step Process",
    subtitle: "From registration to profit withdrawal — simple and transparent",
    steps: [
      {
        title: "Purchase Your Plan",
        description:
          "Choose the plan that best fits your needs and complete your purchase in a few clicks.",
        timeLabel: "2 minutes",
      },
      {
        title: "Start Trading",
        description:
          "Start trading by following the instructions included in your selected plan. Our system guides you step by step.",
        timeLabel: "Varies",
      },
      {
        title: "Withdraw Profits",
        description:
          "Receive your earnings directly to your bank account or preferred wallet within 24–48 hours.",
        timeLabel: "24–48 hours",
      },
    ],
  },

  promo: {
    badge: "Special Offer",
    title: "Candy Bot",
    subtitle:
      'To celebrate the launch of our new bot and proudly mark this milestone, we decided to offer it at an unbeatable price, <strong>available for a limited time only</strong>.',
    cardTitle: "Candy Bot Standard",
    cardSubtitle: "Start your journey today",
    newBadge: "NEW",
    oldPrice: "$99",
    newPrice: "$0",
    limitedNote: "Limited-time offer",
    features: [
      "Full bot access",
      "24/7 support",
      "Advanced dashboard",
      "AI-powered analytics",
    ],
    button: "Discover Candy Bot",
    promoTitle: "Limited-Time Promotion",
    promoText:
      "Sign up <strong>now</strong> and get full access — no payment, no commitment.",
    endsSoon: "Offer ending soon!",
    benefits: [
      "✅ Zero cost",
      "✅ Cancel anytime",
      "✅ Instant activation",
      "✅ Free updates",
    ],
    guarantee: "🔒 Performance guarantee",
  },

  compareSection: {
    planTitle: "Candy Bot Standard",
    planTSubtitle:
      "From traditional solutions to advanced AI, choose the perfect version for your needs",
    planSubtitle: "Everything you need to get started",
    priceFree: "$0",
    priceOld: "$99",
    offerNote: "Limited-time offer",
    features: [
      "7 Forex pairs",
      "24/7 Support",
      "Step-by-step guide",
      "70% profit share",
      "Minimum investment $100",
    ],
    button: "Get it free now",
    popupTitle: "You’re getting Candy Bot Standard",
    popupSubtitle: "Type in your credentials and unlock access to a whole new era.",
    form: {
      name: "Full Name",
      email: "Email",
      password: "Password",
      confirmPassword: "Confirm Password",
      submit: "Register & Get Access",
    },
    disclaimer: 'By clicking "Register" you accept our',
    terms: "Terms of Service",
    privacy: "Privacy Policy",
  },

  comingSoonSection: {
    badge: "COMING SOON",
    title: "Candy Bot Pro",
    subtitle: "Next-generation AI trading",
    priceLabel: "Coming soon",
    priceDescription: "Coming soon",
    features: [
      "Stocks/Forex/Crypto AI model",
      "3 different markets",
      "Priority 24/7 support",
      "Step-by-step setup guide",
      "70% profit split",
      "Minimum investment $500",
    ],
    buttonText: "Available soon",
  },

  faq: {
    title: "Frequently Asked Questions",
    description:
      "All the answers to the most common questions about our service",
    items: [
      {
        question: "How do I start using Candy Bot?",
        answer: "Just click “Free Trial” and follow the registration process.",
      },
      {
        question: "What if I know nothing about trading?",
        answer:
          "No problem: Candy Bot was designed for those who want to enter the trading world without typical risks — or for anyone seeking a simple, safe way to build extra monthly income.",
      },
      {
        question: "What’s the average monthly return?",
        answer:
          "Returns depend on market conditions and your chosen plan, but with the right capital and the right bot, it’s possible to generate a full monthly income.",
      },
      {
        question: "Who are these bots for?",
        answer:
          "Perfect for anyone 18+ looking to trade with less stress or boost monthly income almost automatically.",
      },
      {
        question: "Can I use multiple bots at the same time?",
        answer:
          "Yes! You can activate multiple bots, but each must run on a separate account to avoid conflicts.",
      },
      {
        question: "What is Forex?",
        answer:
          "Forex is the market where currencies like the euro and dollar are traded. It’s the largest in the world, open 24/7 on business days, and lets you profit from exchange-rate movements.",
      },
    ],
  },

  legalSupport: {
    sectionTitle: "Legal & Support",
    terms: "Terms",
    privacy: "Privacy",
    emailLabel: "Email support:",
    email: "support@sweet-trading.com",
    chatLabel: "Chat with us:",
    replyTime: "We usually respond within minutes",
  },

  footer: {
    copyright: "© 2024–2025 Sweet Trading Inc. All rights reserved. 🍬",
    disclaimer:
      "All content on this website is provided for educational and informational purposes only and does not constitute investment, trading, legal, tax, or financial advice, nor a recommendation, solicitation, or offer to buy or sell any financial instrument or to engage in any regulated investment service. Trading involves significant risk and you may lose all of your capital; past performance is not indicative of future results. This website is not intended for distribution or use in any jurisdiction where it would be contrary to local law or require licensing/authorization. Use of this website is at your own risk. Affiliate disclosure: This website may contain affiliate links. If you click on an affiliate link and open an account or make a purchase, we may receive a commission at no additional cost to you.",
  },

  headerLabels: {
    support: "Support",
    faq: "FAQ",
    howItWorks: "The 3-Step Process",
    bots: "Bots",
    login: "Login",
  },
};

/* ---------------- UTILS ---------------- */

function useLockBodyScroll(locked) {
  useEffect(() => {
    if (!locked) return;

    const scrollY = window.scrollY;
    const original = {
      overflow: document.body.style.overflow,
      position: document.body.style.position,
      top: document.body.style.top,
      width: document.body.style.width,
    };

    // iOS-friendly lock (evita “rubber band” + salto pagina)
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = "100%";

    return () => {
      document.body.style.overflow = original.overflow;
      document.body.style.position = original.position;
      document.body.style.top = original.top;
      document.body.style.width = original.width;

      window.scrollTo(0, scrollY);
    };
  }, [locked]);
}

const addPassive = (el, type, handler) => {
  el.addEventListener(type, handler, { passive: true });
  return () => el.removeEventListener(type, handler, { passive: true });
};

const useIsMobile = () => {
  const [isMobile, setIsMobile] = React.useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia("(max-width: 768px)").matches;
  });

  React.useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const update = () => setIsMobile(mq.matches);
    mq.addEventListener?.("change", update);
    return () => mq.removeEventListener?.("change", update);
  }, []);

  return isMobile;
};


const isIOSDevice = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

/** iOS viewport lock */
function useIOSViewportLock() {
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const iOS = isIOSDevice();
    setIsIOS(iOS);

    const setLocked = () => {
      const vh = window.visualViewport?.height ?? window.innerHeight;
      document.documentElement.style.setProperty("--vh-locked", `${vh}px`);
      document.documentElement.style.setProperty("--vh-locked-safe", `${vh}px`);
    };

    const setDynamicBase = () => {
      const supportsLVH = CSS.supports("height", "100lvh");
      document.documentElement.style.setProperty(
        "--vh-dynamic",
        supportsLVH ? "100lvh" : "100svh"
      );
    };

    setDynamicBase();
    setLocked();

    if (!iOS) {
      const cleanR = addPassive(window, "resize", setDynamicBase);
      const cleanO = addPassive(window, "orientationchange", setDynamicBase);
      return () => {
        cleanR();
        cleanO();
      };
    }

    const onOrient = () => setTimeout(setLocked, 250);
    const onVis = () => setTimeout(setLocked, 150);

    const cleanOrient = addPassive(window, "orientationchange", onOrient);
    document.addEventListener("visibilitychange", onVis, { passive: true });

    return () => {
      cleanOrient();
      document.removeEventListener("visibilitychange", onVis);
    };
  }, []);

  return isIOS;
}

/* ---------------- CLOCK ---------------- */
function ClockWidget() {
  const [time, setTime] = React.useState(new Date());
  React.useEffect(() => {
    const id = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  return (
    <div className="relative flex items-center justify-center w-40 h-40 sm:w-44 sm:h-44 rounded-full bg-slate-800/80 border border-indigo-500/30 shadow-2xl backdrop-blur-sm">
      <div className="text-4xl sm:text-5xl font-mono font-light tracking-tighter bg-gradient-to-r from-indigo-300 to-white bg-clip-text text-transparent">
        {time.toLocaleTimeString()}
      </div>
    </div>
  );
}

// Fade-up
function FadeUp({
  as: Tag = "div",
  delay = 0,
  duration = 0.8,
  distance = 12,
  children,
  className = "",
}) {
  const MotionTag = motion(Tag);
  return (
    <MotionTag
      initial={{ y: distance, opacity: 0, filter: "blur(0.5px)" }}
      whileInView={{ y: 0, opacity: 1, filter: "blur(0px)" }}
      viewport={{ once: true, amount: 0.35 }}
      transition={{
        duration,
        ease: [0.25, 1, 0.5, 1],
        delay,
        type: "spring",
        bounce: 0.15,
      }}
      className={className}
    >
      {children}
    </MotionTag>
  );
}


/* ---------------- WHY MOBILE (DINAMICO, OTTIMIZZATO) ---------------- */
function WhyMobile({ whyCopy, iconMap }) {
  const features = whyCopy?.features || [];
  const [active, setActive] = React.useState(0);

  const activeItem = features[active] ?? null;

  // ✅ aggiunto solo per swipe
  const total = features.length;

  // ✅ aggiunto solo per swipe
  const go = (dir) => {
    setActive((prev) => (prev + dir + total) % total);
  };

  // ✅ aggiunto solo per swipe
  const handleDragEnd = (_, info) => {
    if (total < 2) return;

    const offsetX = info.offset.x;
    const velocityX = info.velocity.x;

    const DIST = 70;
    const VELO = 600;

    // swipe left => next
    if (offsetX < -DIST || velocityX < -VELO) go(1);

    // swipe right => prev
    if (offsetX > DIST || velocityX > VELO) go(-1);
  };

  if (!features.length) return null;

  return (
    <section
      id="why"
      className="relative px-4 py-10 text-white md:hidden overflow-hidden"
    >
      {/* SFONDO DINAMICO CHE SEGUE LA FEATURE ATTIVA (SOLO SEZIONE) */}
      <div className="absolute inset-0 pointer-events-none">
        <AnimatePresence mode="wait">
          {activeItem?.image && (
            <motion.div
              key={active}
              initial={{ opacity: 0, scale: 1.05 }}
              animate={{ opacity: 0.55, scale: 1 }}
              exit={{ opacity: 0, scale: 1.02 }}
              transition={{ duration: 0.45, ease: [0.25, 1, 0.5, 1] }}
              className="absolute inset-0"
            >
              <img
                src={activeItem.image}
                alt={activeItem.title}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-slate-950/85 to-slate-950/95" />
            </motion.div>
          )}
        </AnimatePresence>

        {/* blobs morbidi extra */}
        <div className="absolute -top-20 -left-10 w-40 h-40 rounded-full bg-indigo-500/25 blur-3xl" />
        <div className="absolute bottom-0 right-0 w-52 h-52 rounded-full bg-sky-400/15 blur-3xl" />
      </div>

      {/* CONTENUTO */}
      <div className="relative z-10 max-w-md mx-auto">
        {/* HEADER SEZIONE (FISSO) */}
        <div className="text-center mb-6">
          <span className="inline-block text-[0.65rem] uppercase tracking-[0.2em] text-indigo-300 bg-indigo-500/10 px-3 py-1 rounded-full mb-3">
            {whyCopy.title || "Why Sweet Trading"}
          </span>
          <h2 className="text-2xl font-bold text-white mb-2">
            <span className="bg-gradient-to-r from-white via-indigo-100 to-indigo-300 bg-clip-text text-transparent">
              Sweet &amp; Powerful
            </span>
          </h2>
          <p className="text-sm text-slate-100/85 leading-relaxed">
            {whyCopy.description}
          </p>
        </div>

        {/* TABS / PULSANTI FEATURE (Market-Optimized a capo centrato) */}
        <div className="flex flex-wrap justify-center gap-2 pb-2 mb-4">
          {features.map((feat, idx) => {
            const Icon = iconMap[feat.icon];
            const isActive = idx === active;

            const button = (
              <button
                key={idx}
                type="button"
                onClick={() => setActive(idx)}
                className={`flex items-center gap-2 px-3 py-2 rounded-full border text-xs font-medium flex-shrink-0 transition-all ${
                  isActive
                    ? "bg-white text-slate-900 border-white shadow-md shadow-indigo-500/30"
                    : "bg-transparent text-slate-100 border-slate-400/70 hover:border-indigo-400/70 hover:bg-slate-900/30"
                }`}
              >
                {Icon && (
                  <Icon
                    className={`text-sm ${
                      isActive ? "text-indigo-600" : "text-indigo-300"
                    }`}
                  />
                )}
                <span className="text-[0.8rem] leading-snug">{feat.title}</span>
              </button>
            );

            // ✅ solo la 3ª voce (Market-Optimized) va a capo e centrata
            if (idx === 2) {
              return (
                <div key={idx} className="w-full flex justify-center">
                  {button}
                </div>
              );
            }

            return button;
          })}
        </div>

        {/* CARD DELLA FEATURE ATTIVA */}
        <AnimatePresence mode="wait">
          {activeItem && (
            <motion.div
              key={active}
              initial={{ opacity: 0, y: 18, scale: 0.97, filter: "blur(5px)" }}
              animate={{ opacity: 1, y: 0, scale: 1, filter: "blur(0px)" }}
              exit={{ opacity: 0, y: -12, scale: 0.98, filter: "blur(3px)" }}
              transition={{ duration: 0.4, ease: [0.25, 1, 0.5, 1] }}
              className="bg-slate-900/20 backdrop-blur-sm border border-indigo-500/50 rounded-2xl p-4 shadow-xl"
              // ✅ swipe laterale (UNICA aggiunta UI)
              drag={features.length > 1 ? "x" : false}
              dragConstraints={{ left: -80, right: 80 }}
              dragElastic={0.15}
              dragMomentum={false}
              dragSnapToOrigin
              onDragEnd={handleDragEnd}
              style={{ touchAction: "pan-y" }}
            >
              <div className="flex items-center gap-3 mb-3">
                {(() => {
                  const Icon = iconMap[activeItem.icon];
                  return Icon ? (
                    <div className="w-10 h-10 rounded-xl bg-indigo-500/20 border border-indigo-300/40 flex items-center justify-center flex-shrink-0">
                      <Icon className="text-lg text-white" />
                    </div>
                  ) : null;
                })()}

                <div className="text-left">
                  <p className="text-[0.65rem] uppercase tracking-[0.18em] text-indigo-300/85 mb-1">
                    {activeItem.highlight}
                  </p>
                  <h3 className="text-base font-semibold leading-snug">
                    {activeItem.title}
                  </h3>
                </div>
              </div>

              <p className="text-sm text-slate-100/90 leading-relaxed mb-2">
                {activeItem.description}
              </p>

              {/* LINK "find out more" */}
              <div className="pt-1 mb-1">
                <Link
                  to="/strategy"
                  className="inline-flex items-center text-[0.8rem] font-medium text-indigo-300 hover:text-indigo-100 transition-colors whitespace-nowrap"
                >
                  <span>find out more&nbsp;</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-3.5 h-3.5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </Link>
              </div>

              <div className="flex items-center justify-between pt-1 text-[0.7rem] text-slate-300/80">
                <span>
                  Feature {active + 1} / {features.length}
                </span>
                <div className="flex gap-1.5">
                  {features.map((_, i) => (
                    <span
                      key={i}
                      className={`w-1.5 h-1.5 rounded-full transition-all ${
                        i === active
                          ? "bg-indigo-400 scale-110"
                          : "bg-slate-500/60"
                      }`}
                    />
                  ))}
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
}



/* ---------------- WHY TABS (DESKTOP) ---------------- */
function WhyTabs({ whyCopy, iconMap }) {
  const features = whyCopy?.features || [];
  const [active, setActive] = React.useState(0);

  const activeItem = features[active] ?? null;

  if (!features.length) return null;

  return (
    <section
      id="why"
      className="relative py-14 md:py-20 px-4 text-white overflow-hidden"
    >
      {/* SFONDO DINAMICO CHE SEGUE IL RIQUADRO ATTIVO */}
      <div className="pointer-events-none absolute inset-0">
        <AnimatePresence mode="wait">
          {activeItem?.image && (
            <motion.div
              key={active}
              initial={{ opacity: 0, scale: 1.05 }}
              animate={{ opacity: 0.5, scale: 1 }}
              exit={{ opacity: 0, scale: 1.02 }}
              transition={{ duration: 0.5, ease: [0.25, 1, 0.5, 1] }}
              className="absolute inset-0"
            >
              <img
                src={activeItem.image}
                alt={activeItem.title}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              {/* overlay per rendere leggibile il testo */}
              <div className="absolute inset-0 bg-gradient-to-br from-slate-950/90 via-slate-950/80 to-indigo-950/85" />
            </motion.div>
          )}
        </AnimatePresence>

        {/* blobs morbidi extra (statici) */}
        <div className="absolute -top-40 -left-10 w-72 h-72 rounded-full bg-indigo-500/25 blur-3xl" />
        <div className="absolute bottom-0 right-0 w-80 h-80 rounded-full bg-sky-400/15 blur-3xl" />
      </div>

      {/* CONTENUTO SEZIONE */}
      <div className="relative z-10 max-w-6xl mx-auto flex flex-col md:flex-row gap-10 md:gap-14 items-stretch">
        {/* COLONNA SINISTRA */}
        <div className="w-full md:w-5/12 flex flex-col justify-center">
          <span className="inline-block text-[0.65rem] uppercase tracking-[0.25em] text-indigo-300 bg-indigo-500/10 px-3 py-1 rounded-full mb-4">
            {whyCopy.title || "Why Sweet Trading"}
          </span>

          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 leading-tight">
            <span className="bg-gradient-to-r from-white via-indigo-100 to-indigo-300 bg-clip-text text-transparent">
              Sweet &amp; Powerful
            </span>
          </h2>

          <p className="text-sm sm:text-base text-slate-200/85 leading-relaxed mb-6">
            {whyCopy.description}
          </p>

          {/* TABS */}
          <div className="flex flex-wrap gap-3">
            {features.map((feat, idx) => {
              const Icon = iconMap[feat.icon];
              const isActive = idx === active;
              return (
                <button
                  key={idx}
                  type="button"
                  onClick={() => setActive(idx)}
                  className={`inline-flex items-center gap-2 px-3.5 py-2 rounded-full border text-xs sm:text-sm font-medium transition-all
                    ${
                      isActive
                        ? "bg-white text-slate-900 border-white shadow-lg shadow-indigo-500/30"
                        : "bg-slate-900/60 text-slate-200 border-slate-600/80 hover:border-indigo-400/70 hover:bg-slate-800/80"
                    }`}
                >
                  {Icon && (
                    <Icon
                      className={`text-sm ${
                        isActive ? "text-indigo-600" : "text-indigo-300"
                      }`}
                    />
                  )}
                  <span>{feat.title}</span>
                </button>
              );
            })}
          </div>
        </div>

        {/* COLONNA DESTRA: CARD DELLA FEATURE ATTIVA */}
        <div className="w-full md:w-7/12">
          <AnimatePresence mode="wait">
            {activeItem && (
              <motion.div
                key={active}
                initial={{ opacity: 0, y: 24, scale: 0.97, filter: "blur(6px)" }}
                animate={{ opacity: 1, y: 0, scale: 1, filter: "blur(0px)" }}
                exit={{ opacity: 0, y: -18, scale: 0.98, filter: "blur(4px)" }}
                transition={{ duration: 0.45, ease: [0.25, 1, 0.5, 1] }}
                className="relative rounded-2xl overflow-hidden border border-indigo-500/50 bg-slate-900/80 shadow-2xl"
              >
                {/* immagine soft interna (opzionale) */}
                {activeItem.image && (
                  <div className="absolute inset-0 opacity-30">
                    <img
                      src={activeItem.image}
                      alt={activeItem.title}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-br from-slate-950/80 via-slate-950/60 to-slate-900/80" />
                  </div>
                )}

                {/* contenuto card */}
                <div className="relative z-10 p-6 sm:p-7 md:p-8 flex flex-col gap-4">
                  <div className="flex items-center gap-3">
                    {(() => {
                      const Icon = iconMap[activeItem.icon];
                      return Icon ? (
                        <div className="w-11 h-11 rounded-xl bg-indigo-500/20 border border-indigo-300/40 flex items-center justify-center">
                          <Icon className="text-xl text-white" />
                        </div>
                      ) : null;
                    })()}

                    <div className="text-left">
                      <p className="text-[0.7rem] uppercase tracking-[0.2em] text-indigo-300/80 mb-1">
                        {activeItem.highlight}
                      </p>
                      <h3 className="text-lg sm:text-2xl font-semibold">
                        {activeItem.title}
                      </h3>
                    </div>
                  </div>

                  <p className="text-sm sm:text-base text-slate-100/90 leading-relaxed">
                    {activeItem.description}
                  </p>

                  {/* LINK "find out more" */}
                  <div className="pt-1 mb-1">
                    <Link
                      to="/strategy"
                      className="inline-flex items-center text-[0.8rem] font-medium text-indigo-300 hover:text-indigo-100 transition-colors whitespace-nowrap"
                    >
                      <span>find out more&nbsp;</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-3.5 h-3.5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 5l7 7-7 7"
                        />
                      </svg>
                    </Link>
                  </div>

                  <div className="flex items-center justify-between pt-2 text-xs text-slate-300/80">
                    <span>
                      Feature {active + 1} / {features.length}
                    </span>
                    <div className="flex gap-1.5">
                      {features.map((_, i) => (
                        <span
                          key={i}
                          className={`w-1.5 h-1.5 rounded-full transition-all ${
                            i === active
                              ? "bg-indigo-400 scale-110"
                              : "bg-slate-500/60"
                          }`}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
}

/* =========================
   COMPONENTE PRINCIPALE
   ========================= */
export default function SweetTradingPro() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showLangMenu, setShowLangMenu] = useState(false);

  const isMobile = useIsMobile();
  const prefersReducedMotion = useReducedMotion();
  const isIOS = useIOSViewportLock();

  const mobileLangMenuRef = useRef(null);
  const desktopLangMenuRef = useRef(null);

  const navigate = useNavigate();

  const handleRegister = async ({ firstName, lastName, email, password }) => {
  try {
    const cred = await createUserWithEmailAndPassword(auth, email, password);
    await updateProfile(cred.user, {
      displayName: `${firstName} ${lastName}`.trim(),
    });
  } catch (err) {
    console.error("Firebase registration error:", err);
    throw err?.message || "Registrazione fallita. Riprova.";
  }
};


const heroVideoRef = useRef(null);
const heroVideoHasStartedRef = useRef(false);
const [heroVideoVisible, setHeroVideoVisible] = useState(false);

const freezeOnLastFrame = () => {
  const v = heroVideoRef.current;
  if (!v) return;

  try {
    const end = Math.max(0, (v.duration || 0) - 0.05); // ultimo frame “sicuro”
    if (Number.isFinite(end) && end > 0) v.currentTime = end;
    v.pause();
  } catch (e) {
    // niente: fallback naturale
  }

  // IMPORTANTISSIMO: resta visibile anche dopo la fine
  setHeroVideoVisible(true);
};

useEffect(() => {
  const v = heroVideoRef.current;
  if (!v || heroVideoHasStartedRef.current) return;

  const tryPlay = async () => {
    try {
      await v.play();
      heroVideoHasStartedRef.current = true;
      setHeroVideoVisible(true);
    } catch {
      setHeroVideoVisible(false);
    }
  };

  v.addEventListener("loadedmetadata", tryPlay, { once: true });
  return () => v.removeEventListener("loadedmetadata", tryPlay);
}, []);



  // Icon map
  const iconMap = { FaRobot, FaChartLine, FaBolt };

  // Copy mapping
  const heroCopy = {
    title: EN_COPY.heroTitle || "",
    subtitle: EN_COPY.heroSubtitle || "",
    buttonText: EN_COPY.buttonText || "Learn more",
    buttonLink: EN_COPY.buttonLink || "#",
  };
  const clockCopy =
    EN_COPY.clockSection || { title: "", line1: "", line2: "" };
  const whyCopy =
    EN_COPY.whySection || { title: "", description: "", features: [] };
  const processCopy =
    EN_COPY.processSection || { title: "", subtitle: "", steps: [] };
  const promoCopy = EN_COPY.promo || {};
  const compareCopy = EN_COPY.compareSection || { features: [], form: {} };
  const comingCopy = EN_COPY.comingSoonSection || { features: [] };
  const faqCopy = EN_COPY.faq || { items: [] };
  const legalCopy = EN_COPY.legalSupport || {};
  const footerCopy = EN_COPY.footer || {};
  const headerCopy = EN_COPY.headerLabels || {};

  const content = {
    ...processCopy,
    steps: (processCopy.steps || []).map((step, i) => ({
      number: String(i + 1),
      title: step.title || "",
      description: step.description || "",
      timeLabel: step.timeLabel || "",
    })),
  };
  const safeSteps = content.steps || [];
  const clockRef = useRef(null);
  const clockInView = useInView(clockRef, {
    once: true,
    amount: 0.4,
  });

  const clockItemVariants = {
    hidden: { opacity: 0, y: 16, filter: "blur(0.5px)" },
    visible: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      transition: {
        duration: 0.7,
        ease: [0.25, 1, 0.5, 1],
      },
    },
  };

  const clockUnderlineVariants = {
    hidden: { opacity: 0, scaleX: 0 },
    visible: {
      opacity: 1,
      scaleX: 1,
      transition: { duration: 0.45, ease: "easeOut" },
    },
  };

  // header vars
  useEffect(() => {
    let raf = 0;
    const setVars = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const header = document.getElementById("app-header");
        const headerH = header ? header.offsetHeight : 0;
        document.documentElement.style.setProperty("--headerH", `${headerH}px`);
      });
    };
    setVars();
    const cleanResize = addPassive(window, "resize", setVars);
    const cleanOrient = addPassive(window, "orientationchange", setVars);
    document.addEventListener("visibilitychange", setVars);
    return () => {
      cancelAnimationFrame(raf);
      cleanResize();
      cleanOrient();
      document.removeEventListener("visibilitychange", setVars);
    };
  }, []);

  /* ================= RENDER ================= */
  return (
    <div className="min-h-screen font-sans text-white bg-gradient-to-br from-slate-900 via-gray-800 to-indigo-900">
      {/* HEADER */}
      <header
        id="app-header"
        className="w-full bg-slate-800/70 backdrop-blur-lg shadow-sm sticky top-0 z-50 border-b border-slate-700 px-4 py-2 transition-all duration-300"
      >
        <div className="relative flex flex-col md:flex-row items-center md:justify-between w-full gap-4 md:gap-0">
          {/* MOBILE header */}
          <div className="flex justify-between items-center w-full md:hidden">
           <button
  onClick={() => {
    setShowLangMenu(false);
    setIsMobileMenuOpen((v) => !v);
  }}
  className="text-white text-2xl transition-transform duration-300"
  aria-label="Toggle menu"
  aria-expanded={isMobileMenuOpen}
>

             
              {isMobileMenuOpen ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              ) : (
                <FaBars />
              )}
            </button>

            <img
              src="/stt1.png"
              alt="Sweet Trading"
              className="h-10 w-auto cursor-pointer"
              style={{
                background: "transparent",
                mixBlendMode: "normal",
                filter: "none",
              }}
              onClick={() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
                setIsMobileMenuOpen(false);
              }}
            />

            {/* MOBILE language menu */}
            <div className="relative" ref={mobileLangMenuRef}>
              <button
                onClick={() => setShowLangMenu((v) => !v)}
                className="p-1 rounded text-white hover:bg-slate-700/50 focus:outline-none focus:ring-2 focus:ring-slate-500"
                aria-label="Select language"
                aria-expanded={showLangMenu}
                aria-haspopup="menu"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="w-6 h-6"
                >
                  <circle cx="12" cy="12" r="10" />
                  <line x1="2" y1="12" x2="22" y2="12" />
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                </svg>
              </button>

              {showLangMenu && (
                <div
                  role="menu"
                  className="absolute right-0 mt-1 bg-slate-800 border border-slate-600 rounded-md shadow-lg text:white z-50 overflow-hidden"
                >
                  {[
                    { code: "en", label: "EN", flag: "🇬🇧", href: "/" },
                    { code: "it", label: "IT", flag: "🇮🇹", href: "/it" },
                    { code: "de", label: "DE", flag: "🇩🇪", href: "/de" },
                    { code: "es", label: "ES", flag: "🇪🇸", href: "/es" },
                    { code: "fr", label: "FR", flag: "🇫🇷", href: "/fr" },
                    { code: "ar", label: "AR", flag: "🇸🇦", href: "/ar" },
                  ].map((lang) => (
                    <button
                      key={`mobile-${lang.code}`}
                      role="menuitem"
                      onClick={() => {
                        setShowLangMenu(false);
                        navigate(lang.href);
                      }}
                      className="px-2 py-1 w-full text-left hover:bg-slate-700 flex items-center gap-2 text-sm"
                    >
                      <span className="text-base leading-none">
                        {lang.flag}
                      </span>
                      <span className="font-semibold">{lang.label}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* MOBILE slideout menu */}
          
{/* MOBILE slideout menu (ottimizzato + compatto) */}
<AnimatePresence>
  {isMobileMenuOpen && (
    <>
      {/* Backdrop (tap fuori per chiudere) */}
      <motion.button
        type="button"
        aria-label="Close menu"
        onClick={() => setIsMobileMenuOpen(false)}
        className="fixed inset-0 z-40 bg-black/35 backdrop-blur-md"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      />

      {/* Pannello menu */}
     <motion.aside
  role="dialog"
  aria-modal="true"
  initial={{ x: -24, opacity: 0 }}
  animate={{ x: 0, opacity: 1 }}
  exit={{ x: -24, opacity: 0 }}
  transition={{ duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
 className="fixed top-[64px]
       left-0 w-[62vw]
       max-w-[13.5rem] 
       bg-slate-950/85
       backdrop-blur-xl
      rounded-r-xl shadow-lg
    border border-slate-700/60
    z-50 text-sm md:hidden
  "
  style={{
    backdropFilter: "blur(18px)",
    WebkitBackdropFilter: "blur(18px)",
  }}
>

        {/* Header compatto del menu */}
        <div className="flex items-center justify-between px-3 py-2 border-b border-slate-700/70">
          <span className="text-[11px] uppercase tracking-[0.22em] text-indigo-300/80">
            Menu
          </span>

         
        </div>

        {/* Nav (più compatto + scroll interno) */}
        <nav className="flex flex-col p-1 overflow-y-auto">
          {[
            { label: headerCopy.login, to: "/login" },
            { label: headerCopy.support, href: "#support" },
            { label: headerCopy.faq, href: "#faq" },
            { label: headerCopy.howItWorks, href: "#how-it-works" },
            { label: headerCopy.bots, href: "#bots" },
          ].map((item, idx) =>
            item.to ? (
              <Link
                key={idx}
                to={item.to}
                onClick={() => setIsMobileMenuOpen(false)}
                className="
                  px-3 py-2
                  text-[0.92rem] leading-tight
                  text-white
                  rounded-xl
                  hover:bg-slate-800/60
                  active:bg-slate-800/80
                  transition
                "
              >
                {item.label}
              </Link>
            ) : (
              <a
                key={idx}
                href={item.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className="
                  px-3 py-2
                  text-[0.92rem] leading-tight
                  text-white
                  rounded-xl
                  hover:bg-slate-800/60
                  active:bg-slate-800/80
                  transition
                "
              >
                {item.label}
              </a>
            )
          )}
        </nav>

        {/* Footer micro (opzionale) */}
        
      </motion.aside>
    </>
  )}
</AnimatePresence>


          {/* DESKTOP header */}
          <div className="hidden md:flex justify-between items-center w-full">
            <img
              src={logoST}
              alt="Sweet Trading Logo"
              className="h-10 w-auto cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            />

            <nav
              className="flex justify-center flex-1"
              aria-label="Main navigation"
            >
              <div className="flex gap-6">
                <a
                  href="#support"
                  className="text-white text-lg font-medium hover:underline"
                >
                  {headerCopy.support}
                </a>
                <a
                  href="#faq"
                  className="text-white text-lg font-medium hover:underline"
                >
                  {headerCopy.faq}
                </a>
                <a
                  href="#how-it-works"
                  className="text-white text-lg font-medium hover:underline"
                >
                  {headerCopy.howItWorks}
                </a>
                <a
                  href="#bots"
                  className="text-white text-lg font-medium hover:underline"
                >
                  {headerCopy.bots}
                </a>
                <Link
                  to="/login"
                  className="text-white text-lg font-medium hover:underline"
                >
                  {headerCopy.login}
                </Link>
              </div>
            </nav>

            {/* DESKTOP language dropdown */}
{/* DESKTOP language dropdown */}
<div className="relative ml-4" ref={desktopLangMenuRef}>
  <button
    type="button"
    onClick={() => setShowLangMenu((v) => !v)}
    className="text-2xl"
    aria-label="Select language"
    aria-expanded={showLangMenu}
    aria-haspopup="menu"
  >
    🇬🇧
  </button>

  {showLangMenu && (
    <div
      role="menu"
      className="absolute right-0 mt-2 bg-slate-800 border border-slate-600 rounded shadow text-white z-50 overflow-hidden"
    >
      {[
        { code: "en", label: "EN", flag: "🇬🇧", href: "/" },
        { code: "it", label: "IT", flag: "🇮🇹", href: "/it" },
        { code: "de", label: "DE", flag: "🇩🇪", href: "/de" },
        { code: "es", label: "ES", flag: "🇪🇸", href: "/es" },
        { code: "fr", label: "FR", flag: "🇫🇷", href: "/fr" },
        { code: "ar", label: "AR", flag: "🇸🇦", href: "/ar" },
      ].map((lang) => (
        <button
          key={`desktop-${lang.code}`}
          type="button"
          role="menuitem"
          onClick={() => {
            setShowLangMenu(false);
            navigate(lang.href);
          }}
          className="px-4 py-2 hover:bg-slate-700 w-full text-base text-left flex items-center gap-2"
        >
          <span>{lang.flag}</span>
          <span className="font-semibold">{lang.label}</span>
        </button>
      ))}
    </div>
  )}
</div>

          </div>
        </div>
      </header>

      {/* HERO */}
           {/* HERO */}
      <section
        className="relative flex items-center justify-center w-full px-4 py-12 sm:py-16 md:py-20 overflow-x-hidden"
        style={{
          minHeight: isIOS
            ? "var(--vh-locked-safe, var(--vh-locked, 100vh))"
            : "var(--vh-dynamic, 100svh)",
        }}
      >
        {/* Background media */}
        {/* Background media */}
<div className="absolute inset-0 w-full h-full z-0 overflow-hidden pointer-events-none">
  {/* Fallback sempre visibile */}
  <img
    src="/graficos2img.png"
    alt="Background fallback"
    className="absolute inset-0 w-full h-full object-cover"
    loading="eager"
    decoding="async"
  />

  {/* Video sopra: appare SOLO quando sta veramente “playing” */}
  {isMobile ? (
  <video
  key="hero-mobile"
  ref={heroVideoRef}
  className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
    heroVideoVisible ? "opacity-100" : "opacity-0"
  }`}
  autoPlay
  muted
  playsInline
  loop
  preload="metadata"
  poster="/graficos2img.png"
  onPlaying={() => {
    heroVideoHasStartedRef.current = true;
    setHeroVideoVisible(true);
  }}
  onEnded={freezeOnLastFrame}  // (se tieni loop, puoi anche toglierlo)
  onError={() => setHeroVideoVisible(false)}
>
  <source src="/provatelofono.mp4" type="video/mp4" />
</video>

  ) : (
   <video
  key="hero-desktop"
  ref={heroVideoRef}
  className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
    heroVideoVisible ? "opacity-100" : "opacity-0"
  }`}
  autoPlay
  muted
  playsInline
  preload="auto"
  disablePictureInPicture
  poster="/graficos2img.png"
  onPlaying={() => {
    heroVideoHasStartedRef.current = true;
    setHeroVideoVisible(true);
  }}
  onCanPlay={() => setHeroVideoVisible(true)}
  onEnded={freezeOnLastFrame}
  onError={() => setHeroVideoVisible(false)}
>
  <source src="/graficoS.mp4" type="video/mp4" />
  <source src="/graficoS.webm" type="video/webm" />
</video>

  )}
</div>

        {/* Overlay scuro per leggibilità testo */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/70 to-black/85 z-0 pointer-events-none" />

        {/* Contenuto HERO */}
        <div className="relative z-10 max-w-3xl mx-auto text-center px-2">
          <motion.h1
            className="text-4xl sm:text-5xl md:text-6xl font-extrabold leading-tight"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.25, 1, 0.5, 1] }}
          >
            <span className="bg-gradient-to-r from-indigo-100 via-white to-purple-200 bg-clip-text text-transparent">
              {heroCopy.title}
            </span>
          </motion.h1>

          <motion.p
            className="mt-4 text-base sm:text-lg md:text-xl text-slate-100/90 font-medium leading-snug"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6, ease: [0.25, 1, 0.5, 1] }}
          >
            {heroCopy.subtitle}
          </motion.p>

          <motion.div
            className="mt-8"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.35, duration: 0.6 }}
          >
            <a
              href="#promo-purchase"
              onClick={(e) => {
                e.preventDefault();
                const target = document.getElementById("promo-purchase");
                target?.scrollIntoView({ behavior: "smooth" });
              }}
            >
              <button className="bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-500 hover:to-purple-500 text-white px-8 py-3 rounded-lg font-semibold text-base shadow-lg transition-all duration-300 active:scale-95">
                {heroCopy.buttonText}
              </button>
            </a>
          </motion.div>
        </div>
      </section>


      {/* CLOCK SECTION */}
       <section
        ref={clockRef}
        className="relative flex flex-col items-center justify-center py-20 px-6 bg-gradient-to-br from-slate-900 via-gray-900 to-indigo-900/90 text-white text-center overflow-hidden"
      >
        {/* Background */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(3)].map((_, i) => (
            <motion.div
              key={i}
              className="absolute rounded-full bg-indigo-400/20"
              style={{
                width: Math.random() * 5 + 2 + "px",
                height: Math.random() * 5 + 2 + "px",
                top: Math.random() * 100 + "%",
                left: Math.random() * 100 + "%",
              }}
              animate={{
                y: [0, (Math.random() - 0.5) * 100],
                x: [0, (Math.random() - 0.5) * 50],
                opacity: [0.2, 0.8, 0.2],
              }}
              transition={{
                duration: Math.random() * 10 + 10,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            />
          ))}
          <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-indigo-900/20 blur-[80px]" />
          <div className="absolute bottom-1/3 right-1/4 w-48 h-48 rounded-full bg-slate-700/10 blur-[60px]" />
        </div>

        {/* Testo con animazione che parte solo alla prima entrata in viewport */}
        <motion.div
          className="mb-16 w-full text-center relative z-10"
          initial="hidden"
          animate={clockInView ? "visible" : "hidden"}
          variants={{
            hidden: {},
            visible: {
              transition: { staggerChildren: 0.12 },
            },
          }}
        >
          <motion.div
            variants={clockItemVariants}
            className="text-[0.7rem] sm:text-xs font-semibold tracking-[0.2em] uppercase text-indigo-300/80 mb-4"
          >
            {clockCopy.title}
          </motion.div>

          <motion.h2
            variants={clockItemVariants}
            className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight mb-2 leading-tight text-white max-w-4xl mx-auto"
          >
            <span className="bg-gradient-to-r from-white via-indigo-200 to-indigo-400 bg-clip-text text-transparent">
              {clockCopy.line1}
            </span>
          </motion.h2>

          <motion.h2
            variants={clockItemVariants}
            className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight mb-6 leading-tight text-white max-w-4xl mx-auto"
          >
            <span className="bg-gradient-to-r from-indigo-400 to-cyan-400 bg-clip-text text-transparent">
              {clockCopy.line2}
            </span>
          </motion.h2>

          <motion.div
            variants={clockUnderlineVariants}
            className="w-24 h-1 mx-auto bg-gradient-to-r from-indigo-500/60 to-cyan-500/60 rounded-full origin-center"
          />
        </motion.div>

        {/* Clock */}
        <motion.div
          initial={{ opacity: 0, y: 18, scale: 0.96 }}
          animate={
            clockInView
              ? { opacity: 1, y: 0, scale: 1 }
              : { opacity: 0, y: 18, scale: 0.96 }
          }
          transition={{
            delay: 0.35,
            duration: 0.6,
            ease: [0.16, 1, 0.3, 1],
          }}
          className="relative z-10"
        >
          <ClockWidget />
        </motion.div>
      </section>
      {/* WHY */}
      {isMobile ? (
        <WhyMobile whyCopy={whyCopy} iconMap={iconMap} />
      ) : (
        <WhyTabs whyCopy={whyCopy} iconMap={iconMap} />
      )}

     



      {/* PROCESS */}
      <section
        id="how-it-works"
        className="py-12 md:py-28 px-4 md:px-6 bg-gradient-to-br from-slate-900 via-gray-800 to-indigo-900"
        style={{
          scrollSnapAlign: "none",
          overflowAnchor: "none",
          minHeight: "calc(100dvh - var(--headerH, 0px))",
        }}
      >
        <div className="max-w-5xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-12 md:mb-20"
          >
            <h2 className="text-3xl md:text-5xl font-bold text-indigo-200 mb-4 md:mb-6">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-indigo-300">
                {content.title}
              </span>
            </h2>
            <p className="text-lg md:text-xl text-indigo-300 max-w-3xl mx-auto">
              {content.subtitle}
            </p>
          </motion.div>

          <div
            className="relative"
            style={{ contain: "layout paint", transform: "translateZ(0)" }}
          >
            <div className="absolute left-4 md:left-1/2 h-full w-0.5 md:w-1 bg-gradient-to-b from-indigo-500 via-purple-500 to-pink-500 md:transform md:-translate-x-1/2 shadow-lg shadow-indigo-500/50"></div>
            <div className="absolute left-4 md:left-1/2 top-0 w-3 h-3 md:w-4 md:h-4 rounded-full bg-pink-400 md:transform md:-translate-x-1/2 shadow-lg shadow-pink-400/50"></div>
            <div className="absolute left-4 md:left-1/2 top-1/2 w-3 h-3 md:w-4 md:h-4 rounded-full bg-purple-400 md:transform md:-translate-x-1/2 shadow-lg shadow-purple-400/50"></div>
            <div className="absolute left-4 md:left-1/2 bottom-0 w-3 h-3 md:w-4 md:h-4 rounded-full bg-indigo-400 md:transform md:-translate-x-1/2 shadow-lg shadow-indigo-400/50"></div>

            {/* STEP 1 */}
            {safeSteps[0] && (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
                className="flex items-center mb-16 md:mb-24 pl-8 md:pl-0"
              >
                <div className="z-10 flex-shrink-0 w-12 h-12 md:w-16 md:h-16 rounded-full bg-gradient-to-br from-pink-500 to-indigo-600 border-2 md:border-4 border-indigo-300 flex items-center justify-center text-white font-bold text-xl md:text-2xl mr-4 md:mr-8 ml-0 md:ml-auto shadow-lg shadow-pink-500/30">
                  {safeSteps[0].number}
                </div>
                <div className="bg-slate-800/70 backdrop-blur-sm border border-indigo-500/30 md:border-2 rounded-xl md:rounded-2xl p-4 md:p-8 w-full max-w-md md:max-w-lg text-left md:text-right shadow-lg md:shadow-xl shadow-indigo-500/10 hover:shadow-pink-500/20 transition-all duration-300 hover:border-indigo-400/50">
                  <h3 className="text-xl md:text-2xl font-bold text-white mb-2 md:mb-3 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-indigo-300">
                    {safeSteps[0].title}
                  </h3>
                  <p className="text-sm md:text-lg text-indigo-200">
                    {safeSteps[0].description}
                  </p>
                  <div className="mt-3 md:mt-4 flex justify-start md:justify-end">
                    <span className="inline-flex items-center px-2 py-1 md:px-3 md:py-1 rounded-full text-xs md:text-sm font-medium bg-indigo-900/50 text-indigo-200 border border-indigo-700">
                      <FaBolt className="w-3 h-3 md:w-4 md:h-4 mr-1" />{" "}
                      {safeSteps[0].timeLabel}
                    </span>
                  </div>
                </div>
              </motion.div>
            )}

            {/* STEP 2 */}
            {safeSteps[1] && (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
                className="flex items-center mb-16 md:mb-24 pl-8 md:pl-0 relative"
              >
                <div className="absolute left-6 md:left-1/2 z-10 w-12 h-12 md:w-16 md:h-16 rounded-full bg-gradient-to-br from-purple-500 to-indigo-600 border-2 md:border-4 border-indigo-300 flex items-center justify-center text-white font-bold text-xl md:text-2xl shadow-lg shadow-purple-500/30 md:transform md:-translate-x-1/2 transform-none md:ml-2">
                  {safeSteps[1].number}
                </div>

                <div className="ml-20 md:ml-0 bg-slate-800/70 backdrop-blur-sm border border-indigo-500/30 md:border-2 rounded-xl md:rounded-2xl p-4 md:p-8 w-full max-w-md md:max-w-lg text-left shadow-lg md:shadow-xl shadow-indigo-500/10 hover:shadow-purple-500/20 transition-all duration-300 hover:border-indigo-400/50">
                  <h3 className="text-xl md:text-2xl font-bold text-white mb-2 md:mb-3 bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-indigo-300">
                    {safeSteps[1].title}
                  </h3>
                  <p className="text-sm md:text-lg text-indigo-200">
                    {safeSteps[1].description}
                  </p>
                  <div className="mt-3 md:mt-4 flex justify-start">
                    <span className="inline-flex items-center px-2 py-1 md:px-3 md:py-1 rounded-full text-xs md:text-sm font-medium bg-indigo-900/50 text-indigo-200 border border-indigo-700">
                      <FaBolt className="w-3 h-3 md:w-4 md:h-4 mr-1" />{" "}
                      {safeSteps[1].timeLabel}
                    </span>
                  </div>
                </div>
              </motion.div>
            )}

            {/* STEP 3 */}
            {safeSteps[2] && (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.6 }}
                viewport={{ once: true }}
                className="flex items-center pl-8 md:pl-0"
              >
                <div className="z-10 flex-shrink-0 w-12 h-12 md:w-16 md:h-16 rounded-full bg-gradient-to-br from-indigo-500 to-blue-600 border-2 md:border-4 border-indigo-300 flex items-center justify-center text-white font-bold text-xl md:text-2xl mr-4 md:mr-8 ml-0 md:ml-auto shadow-lg shadow-indigo-500/30">
                  {safeSteps[2].number}
                </div>
                <div className="bg-slate-800/70 backdrop-blur-sm border border-indigo-500/30 md:border-2 rounded-xl md:rounded-2xl p-4 md:p-8 w-full max-w-md md:max-w-lg text-left md:text-right shadow-lg md:shadow-xl shadow-indigo-500/10 hover:shadow-blue-500/20 transition-all duration-300 hover:border-indigo-400/50">
                  <h3 className="text-xl md:text-2xl font-bold text-white mb-2 md:mb-3 bg-clip-text text-transparent bg-gradient-to-r from-indigo-400 to-blue-300">
                    {safeSteps[2].title}
                  </h3>
                  <p className="text-sm md:text-lg text-indigo-200">
                    {safeSteps[2].description}
                  </p>
                  <div className="mt-3 md:mt-4 flex justify-start md:justify-end">
                    <span className="inline-flex items-center px-2 py-1 md:px-3 md:py-1 rounded-full text-xs md:text-sm font-medium bg-indigo-900/50 text-indigo-200 border border-indigo-700">
                      <FaStar className="w-3 h-3 md:w-4 md:h-4 mr-1" />{" "}
                      {safeSteps[2].timeLabel}
                    </span>
                  </div>
                </div>
              </motion.div>
            )}
          </div>
        </div>
      </section>

      {/* PROMO */}
      <section
        id="promo-purchase"
        className="relative py-8 sm:py-12 md:py-20 px-4 sm:px-6 bg-gradient-to-br from-slate-900 via-gray-800 to-indigo-900 overflow-hidden"
      >
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-1/2 h-1/3 bg-gradient-to-br from-indigo-900/50 to-transparent"></div>
          <div className="absolute bottom-0 right-0 w-1/2 h-1/3 bg-gradient-to-tl from-purple-900/50 to-transparent"></div>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true, margin: "-50px" }}
            className="text-center mb-6 sm:mb-8"
          >
            <span className="inline-block bg-indigo-600/90 text-white text-[0.65rem] font-medium px-2.5 py-1 rounded-full mb-2">
              {promoCopy.badge}
            </span>
            <h2 className="text-2xl sm:text-3xl font-bold text-white mb-1.5">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-indigo-300 to-purple-300">
                {promoCopy.title}
              </span>
            </h2>
            <p
              className="text-xs sm:text-sm text-indigo-200/90 max-w-[16rem] mx-auto"
              dangerouslySetInnerHTML={{ __html: promoCopy.subtitle }}
            />
          </motion.div>

          <div className="flex flex-col gap-4 sm:gap-5 lg:grid lg:grid-cols-2 lg:gap-6">
            {/* OFFER CARD */}
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true, margin: "-50px" }}
              className="bg-slate-800/90 backdrop-blur-sm rounded-xl border border-indigo-500/30 p-4 sm:p-5 shadow-lg hover:shadow-indigo-500/10 transition-all"
            >
              <div className="flex justify-between items-start mb-3">
                <div>
                  <h3 className="text-base font-bold text-white">
                    {promoCopy.cardTitle}
                  </h3>
                  <p className="text-[0.7rem] text-indigo-300/80">
                    {promoCopy.cardSubtitle}
                  </p>
                </div>
                <span className="bg-green-600/20 text-green-300 text-[0.6rem] font-semibold px-1.5 py-0.5 rounded-full">
                  {promoCopy.newBadge}
                </span>
              </div>

              <div className="mb-3">
                <div className="text-xl font-bold text-white">
                  <span className="line-through text-gray-400/80 text-sm mr-1">
                    {promoCopy.oldPrice}
                  </span>
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-cyan-400">
                    {promoCopy.newPrice}
                  </span>
                </div>
                <p className="text-[0.7rem] text-indigo-300/70 mt-0.5">
                  {promoCopy.limitedNote}
                </p>
              </div>

              <ul className="text-xs sm:text-[0.8rem] text-indigo-200/80 space-y-1.5 mb-4">
                {promoCopy.features?.map((item, i) => (
                  <li key={i} className="flex items-start">
                    <svg
                      className="w-3.5 h-3.5 text-green-400/90 mr-1.5 mt-px flex-shrink-0"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2.5"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    {item}
                  </li>
                ))}
              </ul>

              <button
                onClick={() => {
                  const el = document.getElementById("bots");
                  el?.scrollIntoView({ behavior: "smooth" });
                }}
                className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-500 hover:to-purple-500 text-white font-medium text-center py-2.5 rounded-lg text-xs sm:text-sm transition-all duration-300 active:scale-[0.98]"
              >
                {promoCopy.button}
              </button>
            </motion.div>

            {/* PROMO DETAILS CARD */}
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true, margin: "-50px" }}
              className="bg-slate-800/60 border border-indigo-500/20 rounded-lg p-4 sm:p-5 space-y-3"
            >
              <h3 className="text-sm font-semibold text-white">
                {promoCopy.promoTitle}
              </h3>
              <p
                className="text-xs text-indigo-200/80 leading-relaxed"
                dangerouslySetInnerHTML={{ __html: promoCopy.promoText }}
              />
              <div className="flex items-center text-[0.65rem] text-indigo-300/80">
                <svg
                  className="w-3.5 h-3.5 mr-1.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2.5"
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                {promoCopy.endsSoon}
              </div>

              <ul className="text-xs space-y-1 pt-1.5">
                {promoCopy.benefits?.map((item, i) => (
                  <li key={i} className="text-indigo-200/80">
                    {item}
                  </li>
                ))}
              </ul>

              <p className="text-[0.6rem] text-center text-indigo-400/70 border-t border-indigo-500/20 pt-2">
                {promoCopy.guarantee}
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* BOTS / PLANS */}
      <section
        id="bots"
        className="py-12 px-4 sm:px-6 bg-gradient-to-br from-slate-900 to-indigo-900"
      >
        <div className="max-w-6xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-10 sm:mb-16"
          >
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-3 sm:mb-4 leading-tight">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-indigo-300 to-purple-300">
                {compareCopy.planTitle} & {comingCopy.title}
              </span>
            </h2>
            <p className="text-sm sm:text-lg text-indigo-200 max-w-xl mx-auto leading-relaxed">
              {compareCopy.planTSubtitle}
            </p>
          </motion.div>

          <div className="flex flex-col gap-4 md:gap-6 lg:grid lg:grid-cols-2 lg:gap-8 lg:max-w-4xl lg:mx-auto">
            {/* CANDY BOT STANDARD */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true, margin: "-100px" }}
            >
              <motion.div
                whileHover={{ y: -3 }}
                className="bg-gradient-to-br from-purple-900/50 to-indigo-900/50 border border-purple-400/30 rounded-xl px-4 py-5 shadow-lg relative z-10"
              >
                <div className="absolute top-0 right-0 bg-gradient-to-r from-pink-500 to-purple-600 text-white text-[10px] font-bold px-2 py-1 rounded-bl-md rounded-tr-md">
                  {compareCopy.offerNote}
                </div>

                <div className="mb-3">
                  <h3 className="text-lg font-bold text-white leading-tight">
                    {compareCopy.planTitle}
                  </h3>
                  <p className="text-purple-300 text-xs mt-1">
                    {compareCopy.planSubtitle}
                  </p>
                </div>

                <div className="mb-4">
                  <div className="flex items-end gap-1">
                    <div className="text-2xl font-bold text-white">
                      {compareCopy.priceFree}
                    </div>
                    <div className="text-gray-400 line-through text-sm">
                      {compareCopy.priceOld}
                    </div>
                  </div>
                  <p className="text-purple-300 text-xs">
                    {compareCopy.offerNote}
                  </p>
                </div>

                <ul className="space-y-2 text-xs mb-5">
                  {compareCopy.features?.map((item, i) => (
                    <li key={i} className="flex items-start text-purple-100">
                      <svg
                        className="w-3.5 h-3.5 text-pink-400 mr-2 mt-0.5 flex-shrink-0"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                      <span className="leading-tight">{item}</span>
                    </li>
                  ))}
                </ul>

                <button
                  onClick={() => setShowPopup(true)}
                  className="w-full bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 text-white font-bold py-2.5 rounded-md shadow-md text-xs sm:text-sm transition-all duration-200 active:scale-95"
                >
                  {compareCopy.button}
                </button>
              </motion.div>

              {/* POPUP */}

            </motion.div>

            {/* CANDY BOT PRO COMING SOON */}
            <motion.div
              whileHover={{ y: -3 }}
              className="bg-slate-800/80 border border-indigo-500/20 rounded-xl px-4 py-5 shadow-md relative overflow-hidden"
            >
              <div className="absolute top-0 right-0 bg-amber-500 text-amber-900 text-[10px] font-bold px-2 py-1 rounded-bl-md rounded-tr-md">
                {comingCopy.badge}
              </div>

              <div className="opacity-80">
                <div className="mb-3">
                  <h3 className="text-lg font-bold text-white leading-tight">
                    {comingCopy.title}
                  </h3>
                  <p className="text-indigo-300 text-xs mt-1">
                    {comingCopy.subtitle}
                  </p>
                </div>

                <div className="mb-4">
                  <div className="text-2xl font-bold text-white mb-1">
                    {comingCopy.priceLabel}
                  </div>
                  <p className="text-indigo-300 text-xs">
                    {comingCopy.priceDescription}
                  </p>
                </div>

                <ul className="space-y-2 text-xs mb-5">
                  {comingCopy.features?.map((item, i) => (
                    <li key={i} className="flex items-start text-indigo-300">
                      <svg
                        className="w-3.5 h-3.5 text-indigo-400 mr-2 mt-0.5 flex-shrink-0"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                      <span className="leading-tight">{item}</span>
                    </li>
                  ))}
                </ul>

                <button
                  className="w-full bg-slate-700/70 text-indigo-300 font-medium py-2.5 rounded-md cursor-not-allowed text-xs sm:text-sm"
                  disabled
                >
                  {comingCopy.buttonText}
                </button>
              </div>
            </motion.div>
          </div>

          {/* FAQ */}
          <section
            id="faq"
            style={{
              marginTop: "6rem",
              padding: "48px 16px",
              background: "linear-gradient(135deg, #0f172a, #1e293b, #4338ca)",
              position: "relative",
              overflow: "hidden",
              color: "white",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: -100,
                right: -100,
                width: 300,
                height: 300,
                borderRadius: "50%",
                background:
                  "radial-gradient(circle, rgba(99,102,241,0.2) 0%, rgba(0,0,0,0) 70%)",
                opacity: 0.3,
                zIndex: 0,
              }}
            />
            <div
              style={{
                position: "absolute",
                bottom: -50,
                left: -50,
                width: 200,
                height: 200,
                borderRadius: "50%",
                background:
                  "radial-gradient(circle, rgba(139,92,246,0.15) 0%, rgba(0,0,0,0) 70%)",
                opacity: 0.2,
                zIndex: 0,
              }}
            />

            <div
              style={{
                maxWidth: "1200px",
                margin: "0 auto",
                position: "relative",
                zIndex: 1,
              }}
            >
              <div style={{ textAlign: "center", marginBottom: "32px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "16px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "40px",
                      color: "#a78bfa",
                      background: "rgba(99,102,241,0.2)",
                      padding: "16px",
                      borderRadius: "50%",
                      width: "72px",
                      height: "72px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    ?
                  </div>
                  <h2>{faqCopy.title}</h2>
                  <p>{faqCopy.description}</p>
                </div>
              </div>

              <div
                style={{
                  borderRadius: "8px",
                  overflow: "hidden",
                  boxShadow: "0 2px 10px rgba(67,56,202,0.3)",
                }}
              >
                {faqCopy.items?.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      background: "#1e293b",
                      borderBottom: "1px solid #4338ca",
                      transition: "all 0.3s",
                    }}
                  >
                    <button
                      onClick={(e) => {
                        const answer = e.currentTarget.nextElementSibling;
                        const isOpen = answer.style.maxHeight === "500px";
                        answer.style.maxHeight = isOpen ? "0" : "500px";
                        answer.style.opacity = isOpen ? "0" : "1";
                        answer.style.padding = isOpen
                          ? "0 16px"
                          : "0 16px 16px 16px";
                        e.currentTarget
                          .querySelector("svg")
                          .style.setProperty(
                            "transform",
                            isOpen ? "rotate(0deg)" : "rotate(45deg)"
                          );
                      }}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        padding: "16px",
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        textAlign: "left",
                        color: "white",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: 500,
                          color: "white",
                          transition: "color 0.3s",
                        }}
                      >
                        {item.question}
                      </span>
                      <svg
                        style={{
                          width: "20px",
                          height: "20px",
                          color: "#a78bfa",
                          transition: "transform 0.3s",
                          flexShrink: 0,
                        }}
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                        />
                      </svg>
                    </button>

                    <div
                      style={{
                        overflow: "hidden",
                        maxHeight: "0",
                        opacity: "0",
                        padding: "0 16px",
                        transition: "all 0.3s ease-in-out",
                      }}
                    >
                      <p style={{ color: "#c7d2fe", margin: 0 }}>
                        {item.answer}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>
      </section>

<section className="relative overflow-hidden border-y border-gray-800/60 py-10 sm:py-14">
  {/* Background image (public) + gradient fallback */}
  <div
    className="absolute inset-0"
    style={{
      backgroundImage:
        "url(/xfinebanner.jpg), radial-gradient(900px 380px at 50% 0%, rgba(56,189,248,0.16), transparent 55%), linear-gradient(135deg, rgba(2,6,23,0.98), rgba(2,6,23,0.86) 45%, rgba(30,58,138,0.55))",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      filter: "brightness(0.58) saturate(1.12)",
      transform: "scale(1.02)",
    }}
  />

  {/* Soft overlay */}
  <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-[#00122a]/60 to-black/80" />
  <div className="absolute -top-24 -right-24 h-64 w-64 rounded-full bg-sky-500/10 blur-3xl" />
  <div className="absolute -bottom-28 -left-28 h-72 w-72 rounded-full bg-indigo-500/10 blur-3xl" />

  {/* Content */}
  <div className="relative z-10 mx-auto max-w-3xl px-4 sm:px-6">
    <div className="mt-1 rounded-3xl border border-white/10 bg-white/[0.06] p-5 sm:p-7 backdrop-blur-xl shadow-[0_18px_55px_-28px_rgba(0,0,0,0.75)]">
      <div className="flex flex-col items-center text-center">
        {/* Logo + domain (smaller, secondary) */}
        <div className="mb-4 flex flex-col items-center opacity-80">
          <img
            src="/xfinelogobanner.svg"
            alt="X-Fine Logo"
            className="h-8 sm:h-9 w-auto"
            loading="lazy"
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
          <div className="mt-1 text-[10px] sm:text-[11px] font-medium tracking-wide text-slate-200/60">
            x-fine.com
          </div>
        </div>

        {/* Main title (more prominent) */}
        <h2 className="text-[1.75rem] sm:text-[2.35rem] font-extrabold leading-[1.05] text-white drop-shadow-[0_12px_28px_rgba(0,0,0,0.65)]">
          Trusted by{" "}
        <span className="bg-gradient-to-r from-indigo-400 via-violet-300 to-fuchsia-200 bg-clip-text text-transparent">
          thousands of traders worldwide
        </span>
        </h2>

        {/* Sub */}
        <p className="mt-3 text-sm sm:text-base text-slate-200/80 leading-relaxed max-w-[52ch]">
          Driven by excellence, discipline, and performance — empowering traders to perform at the highest level.
        </p>

        {/* Micro disclaimer */}
        <p className="mt-5 text-[10px] sm:text-[11px] text-slate-300/55 max-w-[44ch]">
          Trading involves risk. Promotional content — not financial advice.
        </p>
      </div>
    </div>
  </div>
</section>



      {/* LEGAL & SUPPORT */}
      <div className="flex justify-center items-center mt-12">
        <div className="p-6 w-full max-w-md">
          <h3 className="text-2xl font-bold text-gray-100 mb-8 text-center">
            {legalCopy.sectionTitle}
          </h3>

          <div className="space-y-5">
            <div className="flex flex-col items-center space-y-4 py-3">
              <div className="flex space-x-6">
                <a
                  href="/terms"
                  className="text-gray-400 hover:text-blue-400 transition-colors flex items-center"
                >
                  <svg
                    className="w-4 h-4 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                  {legalCopy.terms}
                </a>
                <a
                  href="/privacy"
                  className="text-gray-400 hover:text-blue-400 transition-colors flex items-center"
                >
                  <svg
                    className="w-4 h-4 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                    />
                  </svg>
                  {legalCopy.privacy}
                </a>
              </div>
            </div>

            <div className="flex flex-col items-center space-y-4 pt-5 mt-5 border-t border-gray-700">
              <div className="flex flex-col items-center">
                <p className="text-sm text-gray-400 mb-1">
                  {legalCopy.emailLabel}
                </p>
                <a
                  href={`mailto:${legalCopy.email}`}
                  className="text-blue-400 hover:text-white text-sm text-center break-all"
                >
                  {legalCopy.email}
                </a>
              </div>

              <div className="flex flex-col items-center mt-6">
                <p className="text-sm text-gray-400 mb-2">
                  {legalCopy.chatLabel}
                </p>
                <a
                  href="https://t.me/assistenceST"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-blue-500 hover:bg-blue-600 text-white rounded-full p-3 transition-colors"
                >
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9.74 15.29l-.39 3.48c.56 0 .8-.24 1.1-.53l2.64-2.5 5.47 4.01c1.01.56 1.73.27 1.99-.93l3.61-16.78c.33-1.53-.56-2.13-1.54-1.75L1.63 9.71c-1.49.58-1.47 1.41-.27 1.79l4.62 1.44 10.73-6.78c.51-.31.97-.14.59.2l-8.69 7.93z" />
                  </svg>
                </a>
                <p className="text-xs text-gray-500 mt-2">
                  {legalCopy.replyTime}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* PAYMENT METHODS */}
      <section className="flex flex-wrap justify-center gap-4 py-6 max-w-4xl mx-auto mt-12 px-4 overflow-x-hidden">
        {[option1, option4, option6, option7, option8, option9, option10, option11].map(
          (icon, idx) => (
            <img
              key={idx}
              src={icon}
              alt={`Payment method ${idx + 1}`}
              className="h-5 w-auto sm:h-6 md:h-8"
            />
          )
        )}
      </section>

      {/* FOOTER */}
      <footer
        id="support"
        className="text-center py-12 bg-slate-900 text-indigo-300 text-sm border-t border-slate-700"
      >
        {footerCopy.copyright}
        <p className="mt-4 max-w-5xl mx-auto px-4 text-xs text-indigo-400">
          {footerCopy.disclaimer}
        </p>
      </footer>

      {/* Reused popup */}
     <PurchasePopup
  open={showPopup}
  product={compareCopy.planTitle}
  onClose={() => setShowPopup(false)}
  onRegister={handleRegister} // ⬅️ qui agganciamo Firebase
  // opzionale: se vuoi passare esplicitamente la config di EmailJS
  emailJs={{
    service: "service_yekp18n",
    template: "template_6jy0au8",
    publicKey: "qcGu9Ew-DYw_l-ScC",
  }}
       copy={{ compareSection: compareCopy }}
/>

    </div>
  );
}
